module.exports = __webpack_public_path__ + "img/69_7.d65881d4.png";